import React, { useEffect } from "react";
import { Space, Layout } from "antd";
import { useNavigate } from "react-router-dom";

import FormLogin from "../../components/forms/formLogin";
import { useThemedLogo } from "../../theme/useThemedLogo";

export default function Auth() {
  const navigate = useNavigate();
  const logo = useThemedLogo();

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      navigate("/app");
    }
  });

  return (
    <Layout>
      <Space
        direction="vertical"
        align="center"
        style={{
          display: "flex",
          minHeight: "100vh",
          justifyContent: "center",
          padding: "2rem 1.5rem",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "end",
            gap: 15,
            maxWidth: "100%",
          }}
        >
          <img
            src={logo}
            alt="Mailinflow Logo"
            height={60}
            style={{ maxWidth: "100%", height: "auto", maxHeight: 60 }}
          />
        </div>
        <FormLogin />
      </Space>
    </Layout>
  );
}
